export const PAYMENT_OPTIONS = [
  { label: "Cash", value: "Cash" },
  { label: "Card", value: "Card" },
  { label: "Online", value: "Online" },
  { label: "UPI", value: "UPI" },
];
